import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleMake.ImportExcel.IRequest;
type Response = Api.Core.VehicleMake.ImportExcel.IResponse;
type Headers = Api.Core.VehicleMake.ImportExcel.IHeaders;
const url = '/api/ProductManagement/VehicleMake/ImportExcel';
export default async function vehicleMakeImportExcelApi(request: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    body: request,
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
